import { useMemo } from 'react';
import { FilterMeta, Filters } from 'types/generated/graphql';
import { SearchFilterMeta, SearchFiltersMeta } from '../types';

const convertToSearchFilterMeta = (
    metaData?: (FilterMeta | undefined)[],
): SearchFilterMeta | undefined => {
    if (!metaData) {
        return undefined;
    }

    return Object.fromEntries(
        metaData
            .filter((data) => data)
            .map((data) => {
                return [data?.name, data?.value];
            }),
    );
};

const useSearchFiltersMeta = ({
    filterMetaObj,
}: {
    filterMetaObj?: Filters;
}): SearchFiltersMeta => {
    const filterInstrumentsMeta = useMemo(
        () => convertToSearchFilterMeta(filterMetaObj?.instrumentFilters),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [filterMetaObj?.instrumentFilters],
    );

    const filterGenresMeta = useMemo(
        () => convertToSearchFilterMeta(filterMetaObj?.genreFilters),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [filterMetaObj?.genreFilters],
    );

    const filterTypesMeta = useMemo(
        () => convertToSearchFilterMeta(filterMetaObj?.sampleTypeFilters),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [filterMetaObj?.sampleTypeFilters],
    );

    const filterSfxsMeta = useMemo(
        () => convertToSearchFilterMeta(filterMetaObj?.sfxFilters),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [filterMetaObj?.sfxFilters],
    );

    const filterTagsMeta = useMemo(
        () => convertToSearchFilterMeta(filterMetaObj?.tagFilters),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [filterMetaObj?.tagFilters],
    );

    return {
        filterInstrumentsMeta,
        filterGenresMeta,
        filterTypesMeta,
        filterSfxsMeta,
        filterTagsMeta,
    };
};

export default useSearchFiltersMeta;
